var values = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xlg: 1900
};
export var keys = ['xs', 'sm', 'md', 'lg', 'xl', 'xlg'];
var units = 'px';

var create = function create(key) {
  var value = typeof values[key] === 'number' ? values[key] : key;
  return "@media (min-width: ".concat(value).concat(units, ")");
};

export default {
  keys: keys,
  values: values,
  create: create,
  up: function up(breakpoint) {
    return "@media screen and (min-width: ".concat(values[breakpoint], "px)");
  },
  down: function down(breakpoint) {
    return "@media screen and (max-width: ".concat(values[breakpoint], "px)");
  }
};